module.exports = __webpack_public_path__ + "img/institute-for-political-management-logo.4716b312.png";